import { saveAs } from "file-saver";

import { useTranslation } from "react-i18next";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import countriesList from "i18n-iso-countries";
import countriesJson from "i18n-iso-countries/langs/en.json";

const FarmsTable = ({farms}) => {
    const { t } = useTranslation();
    countriesList.registerLocale(countriesJson);
    farms = farms.map((farm) => {
        const newFarm = {
            account_name: farm.account_name,
            name: farm.name,
            country_name: countriesList.getName(farm.country_code, "en"),
            crops: farm.crops.join(" "),
            nodes: farm.nodes,
            centro_costo: farm.centro_costo,
            latitud: farm.latitud,
            longitud: farm.longitud,
            dist: farm.dist.join(" "),
            links: [`https://www.dropcontrol.com/site/dashboard/campo.do?cuentaId=${farm.account_id}&campoId=${farm.farm_id}`,
                `https://setup.wiseconn.com/awi/management.jsf?ca=${farm.farm_id}&page=campo`,
                `https://admin.dropcontrol.com/farms?farm=${farm.farm_id}`]
        };
        return newFarm;
    });
    const exportExcel = () => {
        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(farms);
            const workbook = { Sheets: { "data": worksheet }, SheetNames: ["data"] };
            const excelBuffer = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
            saveAsExcelFile(excelBuffer, "farms");
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new globalThis.Blob([buffer], {
            type: EXCEL_TYPE
        });

        saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
    };

    const header = (
        <div className="flex align-items-center export-buttons">
            <Button type="button" onClick={exportExcel} className="p-button-success mr-2" data-pr-tooltip="XLS">
                <span className="flex align-items-center">
                    <i className="pi pi-file-excel" />
                </span>
                <div className="ml-3">
                    <span>
                        {t("map.export")}
                    </span>
                </div>
            </Button>
        </div>
    );

    return (
        <div className="grid">
            <div className="col-12 md:col-12">
                <div className="card">
                    <DataTable
                        value={farms}
                        header={header}
                        paginator
                        responsiveLayout="scroll"
                        dataKey="farm_id" emptyMessage={t("map.noFarmsFound")}
                        rows={5}
                    >
                        <Column field="account_name" header={t("map.accountName")} style={{width:"10%"}} />
                        <Column field="name" header={t("map.farmName")} style={{width:"10%"}} />
                        <Column field="country_name" header={t("map.countryName")} style={{width:"10%"}} />
                        <Column field="crops" header={t("map.crops")} style={{width:"10%"}} />
                        {/* <Column
                            field="crops" header="Crops" body={(rowData) => rowData.crops.map((crop, index) => (
                                <div key={index}>
                                    {crop}
                                </div>
                            ))} style={{width:"10%"}}
                        /> */}
                        <Column field="nodes" header={t("map.nodes")} style={{width:"10%"}} />
                        <Column field="centro_costo" header={t("map.costCenter")} style={{width:"10%"}} />
                        <Column field="latitud" header={t("map.latitude")} style={{width:"10%"}} />
                        <Column field="longitud" header={t("map.longitude")} style={{width:"10%"}} />
                        <Column field="dist" header={t("map.integrator")} style={{width:"10%"}} />
                        <Column
                            field="links" header={t("map.links")} body={(rowData) => (
                                <div>
                                    <a href={rowData.links[0]} target="_blank">
                                        {t("infoWindow.dropControl")}
                                    </a>
                                    <br />
                                    <a href={rowData.links[1]} target="_blank">
                                        {t("infoWindow.setUp")}
                                    </a>
                                    <br />
                                    <a href={rowData.links[2]} target="_blank">
                                        {t("infoWindow.admin")}
                                    </a>
                                </div>
                            )} style={{width:"10%"}}
                        />
                    </DataTable>
                </div>
            </div>
        </div>
    );
};
export default FarmsTable;
/* <div className="grid">
            <div className="col-12">
                <div className="card">
                    <DataTable value={farms} >
                        <Column field="account_name" header="Account Name" style={{width:"14%"}} />
                        <Column field="name" header="Farm Name" style={{width:"14%"}} />
                        <Column field="country_name" header="Country Name" style={{width:"14%"}} />
                        <Column field="crops" header="Crops" style={{width:"14%"}} />
                        <Column field="nodes" header="Nodes" style={{width:"14%"}} />
                        <Column field="latitud" header="Latitude" style={{width:"14%"}} />
                        <Column field="longitud" header="Longitude" style={{width:"14%"}} />
                    </DataTable>

                </div>
            </div>
        </div> */
